import React, { Fragment, useCallback, useState } from 'react'
import cx from 'classnames'

import styles from './KBTile.module.css'

import HappyFoxLogo from 'Logos/happyfox.svg'
import ZendeskLogo from 'Logos/zendesk.svg'
import CsvFileIcon from 'Icons/file.svg'
import PencilIcon from 'Icons/pencil.svg'
import BinIcon from 'Icons/bin.svg'

import Button from 'Design/components/Button'

import * as date from 'Utils/date'
import { useDeleteKBMutation, useSyncKbMutation } from '../kb.service'
import EditKB from '../EditKb'
import Heading from 'Design/components/Heading'

const SourceIcons = {
  happyfox_helpdesk: HappyFoxLogo,
  zendesk_support: ZendeskLogo,
  csv_file: CsvFileIcon
}

const KBTile = (props) => {
  const { id, type, name, source, noOfarticles, ignoredSections, syncStatus, lastSyncAt, isFetching } = props
  const Icon = SourceIcons[type]

  const [syncKB, syncKBResult] = useSyncKbMutation()
  const [deleteKB, deleteKBResult] = useDeleteKBMutation()
  const [showSettings, setShowSettings] = useState(id === 242)

  const handleSyncClick = () => {
    syncKB(id).unwrap()
  }

  const handleDeleteClick = () => {
    deleteKB(id)
  }

  const handleEditClick = () => {
    setShowSettings(true)
  }

  const hideEditPanel = useCallback(() => {
    setShowSettings(false)
  }, [])

  const disableSyncButton = syncKBResult.isLoading || isFetching
  const disableDeleteButton = deleteKBResult.isLoading || isFetching

  return (
    <Fragment>
      {showSettings && <EditKB hide={hideEditPanel} id={id} name={name} ignoredSections={ignoredSections} />}
      <div className={styles.Tile}>
        <div className={styles.Head}>
          <Icon width='23' height='23' />
        </div>
        <div className={styles.Body}>
          <div className={styles.Description}>
            <Heading level={2}>{name}</Heading>
            <p className={styles.Source}>{source}</p>
          </div>
          <div className={styles.Stats}>
            <div className={styles.Articles}>
              <span className={styles.Count}>{noOfarticles}</span> Articles
            </div>
            <div className={styles.IgnoredSections}>
              <span className={styles.Count}>{ignoredSections.length}</span> Ignored sections
            </div>
          </div>
        </div>
        <div className={styles.Footer}>
          {(syncStatus === 'completed' || syncStatus === 'not_started') && (
            <Fragment>
              <Button variant='secondary' size='sm' onClick={handleSyncClick} disabled={disableSyncButton}>
                Sync
              </Button>
              {lastSyncAt && <span className={styles.TimeAgo}>Last synced {date.ago(lastSyncAt, false, true)}</span>}
              <button className={styles.Action} onClick={handleEditClick}>
                <PencilIcon width='15' height='15' />
              </button>
            </Fragment>
          )}

          {(syncStatus === 'in_progress' || syncStatus === 'retraining' || !syncStatus) && (
            <Button variant='secondary' size='sm' disabled>
              Sync in progress
            </Button>
          )}

          {syncStatus === 'validation_failed' && (
            <React.Fragment>
              <span className={styles.FailedText}>Validation failed. Please delete and try again.</span>
              <button
                className={cx(styles.Action, styles.ActionDanger)}
                onClick={handleDeleteClick}
                disabled={disableDeleteButton}
              >
                <BinIcon width='11' height='11' />
              </button>
            </React.Fragment>
          )}

          {syncStatus === 'failed' && (
            <Fragment>
              <Button variant='secondary' size='sm' onClick={handleSyncClick} disabled={disableSyncButton}>
                Sync
              </Button>
              <span className={styles.FailedText}>Sync failed. Please try again.</span>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default KBTile
